var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrary(_ref, svgRef) {
  var _ref2, _ref3, _ref4;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.16602 7.40234C2.16602 4.57434 2.16602 3.15934 3.04502 2.28134C3.92302 1.40234 5.33802 1.40234 8.16602 1.40234H12.166C14.994 1.40234 16.409 1.40234 17.287 2.28134C18.166 3.15934 18.166 4.57434 18.166 7.40234V15.4023C18.166 18.2303 18.166 19.6453 17.287 20.5233C16.409 21.4023 14.994 21.4023 12.166 21.4023H8.16602C5.33802 21.4023 3.92302 21.4023 3.04502 20.5233C2.16602 19.6453 2.16602 18.2303 2.16602 15.4023V7.40234Z",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.064 15.4023H6.06402C5.13402 15.4023 4.66902 15.4023 4.28702 15.5043C3.77833 15.6407 3.31451 15.9087 2.94219 16.2812C2.56988 16.6536 2.30218 17.1176 2.16602 17.6263",
    stroke: "#1A4338",
    style: (_ref3 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16602 6.40234H14.166M6.16602 9.90234H11.166M17.666 18.4023H6.16602",
    stroke: "#1A4338",
    style: (_ref4 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.4b3549c9.svg";
export { ForwardRef as ReactComponent };